require('./dist/global/ds6/global.css');
